import * as api from '../../api';
import * as utils from '../../utils';
import { ACTIONS } from '../../constants';

// ---------------------------------------------------
// Get Day
// ---------------------------------------------------

export const setStartDayId = startId => dispatch => {
  // todo - temp/quick - should be really there?
  dispatch({
    type: ACTIONS.SET_START_DAY,
    startId
  });

  // todo - 7 used as hotfix - this whole thing need complete revise
  for (let i = 0; i < 7; i += 1) {
    const tempDate = utils.getDateByDayId(startId + i);
    const idMonth = tempDate.getMonth();
    const idDay = tempDate.getDate() - 1;

    dispatch({
      type: ACTIONS.DAY_FETCH,
      idMonth,
      idDay
    });
    api
      .fetchDay(idMonth, idDay)
      .then(data => {
        dispatch({
          type: ACTIONS.DAY_FETCH_DONE,
          data
        });
      })
      .catch(() => {
        dispatch({
          type: ACTIONS.DAY_FETCH_ERROR
        });
      });
  }
};

export const columnsUpdate = columns => ({
  type: ACTIONS.COLUMNS_UPDATE,
  columns
});

export const daySelectSwitch = show => ({
  type: ACTIONS.DAY_SELECT_SWITCH,
  show
});



// WEBPACK FOOTER //
// ./src/redux/actions/index.js